import type { User } from '#modules/auth/types';

export function checkOnboarding(user: User) {
  switch (true) {
    case !checkCompleteProfile(user, user.onboarding?.skipped_complete_profile || false):
      return 'complete-profile';
    case !checkCompanyInfo(user, user.onboarding?.skipped_complete_profile || false):
      return 'company-info';
    default:
      return true;
  }
}

export function checkCompleteProfile(account: User, skipped: boolean) {
  return Boolean((account.first_name && account.last_name && account.phone_number && account.trade_roles) || skipped);
}

export function checkCompanyInfo(account: User, skipped: boolean) {
  return Boolean(account.company || skipped);
}
